<template>
  <div class="page m-page">
    <img
      src="https://directimg.miaocang.cc/mpImg/introduction@2x.png"
      draggable="false"
      oncontextmenu="return false;"
      class="unselectable"
    />
  </div>
</template>

<script>
export default {
  name: 'Introduction'
}
</script>

<style lang="less" scoped>
.page {
  width: 100vw;
  background-color: #167849;
  img {
    width: 100%;
  }
}
</style>
